/**
 * Los Angeles County Building Code Configuration
 *
 * Local amendments and specifics for unincorporated LA County
 * (LA County Department of Public Works - Building & Safety)
 * Inherits from California base codes.
 *
 * Reference: https://dpw.lacounty.gov/building-and-safety/
 */

export const LA_COUNTY = {
  id: 'la-county',
  inherits: 'california',

  // Jurisdiction metadata
  jurisdiction: {
    name: 'Los Angeles County (Unincorporated)',
    shortName: 'LA County',
    department: 'LA County Department of Public Works - Building & Safety',
    website: 'https://dpw.lacounty.gov/building-and-safety/',
    permitPortal: 'https://dpw.lacounty.gov/bsd/permitservices/',
    phone: '(626) 458-3180',
  },

  // Code adoption info
  codeAdoption: {
    codeYear: '2022',
    effectiveDate: '2023-01-01',
    localAmendments: 'Los Angeles County Code Title 26',
    localCodeRef: ' as amended by LA County Title 26',
    notes: '2022 California Building Code as amended by LA County',
  },

  // Code compliance section (jurisdiction-specific)
  codeComplianceSection: {
    id: 'code-compliance',
    title: 'CODE COMPLIANCE',
    scope: [], // Always include
    items: [
      {
        text: 'All work shall comply with the following codes as adopted and amended by Los Angeles County:',
        subItems: [
          '{codeYear} California Residential Code (CRC)',
          '{codeYear} California Building Code (CBC)',
          '{codeYear} California Electrical Code (CEC)',
          '{codeYear} California Mechanical Code (CMC)',
          '{codeYear} California Plumbing Code (CPC)',
          '{codeYear} California Energy Code (Title 24, Part 6)',
          '{codeYear} California Green Building Standards Code (CALGreen)',
          'Los Angeles County Code Title 26 (Building Code)',
        ],
      },
      'Contractor shall obtain all required permits from LA County Building & Safety prior to commencement of work.',
      'Contractor shall schedule and obtain approval of all required inspections.',
      'All work shall be performed by properly licensed contractors in accordance with California Contractors State License Law.',
    ],
  },

  // Sections to override from base
  sectionOverrides: {
    // No full overrides needed
  },

  // Items to append to base sections
  sectionAppends: {
    // LA County has some specific requirements in fire hazard zones
    'fire-safety': [
      'Properties in Fire Hazard Severity Zones shall comply with additional requirements per LA County Fire Code Chapter 49.',
    ],
  },

  // Additional sections unique to this jurisdiction
  additionalSections: [
    {
      id: 'la-county-fire-zones',
      title: 'FIRE HAZARD SEVERITY ZONES (WHERE APPLICABLE)',
      scope: ['addition', 'full-remodel', 'structural'],
      items: [
        'Verify Fire Hazard Severity Zone designation with LA County Fire Department.',
        'Properties in Very High Fire Hazard Severity Zones (VHFHSZ) require additional fire-resistive construction per CBC Chapter 7A.',
        'Defensible space and vegetation management required per LA County Fire Code.',
        'Class A roof covering required in fire hazard zones.',
      ],
    },
  ],
};

export default LA_COUNTY;
